export default {
  getTree(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/funnel/tree/${params.id}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setFunnels", results);
          context.commit("setPagination", { count, next, previous });
          resolve({ data: { results, count, next, previous } });
        })
        .catch(reject);
    });
  },
  get(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      window.axios
        .get(`/funnel?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setFunnels", results);
          context.commit("setPagination", { count, next, previous });
          resolve({ data: { results, count, next, previous } });
        })
        .catch(reject);
    });
  },
  getDetails(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/funnel/${id}`)
        .then(({ data }) => {
          context.commit("setFunnel", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  post(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/funnel", params)
        .then(({ data }) => {
          resolve({ data });
        })
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/funnel/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  delete(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/funnel/${id}`)
        .then(resolve)
        .catch(reject);
    });
  }
};
